/**
 * Contains configurations for the application
 */
import * as config from '../../appconfig.json';
export const APP_CONFIG = {...config};
